<template>
  <div class="Agreement">
    <div v-html="htmls"></div>
    <p>
      <br />
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      htmls: `    <div>
      <h2
        style="font-size:16pt; line-height:172%; margin:13pt 0pt; orphans:0; page-break-after:avoid; page-break-inside:avoid; text-align:center; widows:0"
      >
        <span style="font-family:黑体; font-size:16pt; font-weight:bold"
          >用户使用协议</span
        >
      </h2>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt; font-weight:bold"
          >在接受本平台服务之前，请务必仔细阅读本条款并同意本声明。您使用本平台或接受本平台服务的行为，都将被视作是对本声明全部内容的无异议认可；如有异议，请即刻停止使用本平台。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt">
          一、您在使用本平台的所有行为，必须以善意且谨慎的态度行事；不得故意损害或者弱化本平台的各类合法权益，不得利用本平台以任何直接或间接的方式从事违反中国法律法规、国际公约以及社会公德的行为，且应当恪守下述承诺：</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:Calibri; font-size:10.5pt">1</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、不得将本平台以及与之相关的网络服务用作非法用途以及非正当用途；</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:Calibri; font-size:10.5pt">2</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、不得干扰或扰乱本平台以及与之相关的网络服务；</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt 0pt 0pt 10.5pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"
      >
        <span style="font-family:Calibri; font-size:10.5pt">3</span
        ><span style="font-family:宋体; font-size:10.5pt">、</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >遵守与本平台以及与之相关的网络服务的规则、协议、规定、程序和惯例。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; text-indent:10.5pt; widows:0"
      >
        <span style="font-family:Calibri; font-size:10.5pt">4</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、店方向平台申请开通的营销活动产品、会员活动产品等由于国家对行业政策调控、技术接口限制等因素给消费用户造成的损失及影响，店方将负责处理并承担责任。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">二</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台只在中国提供本服务，平台的所有服务无意提供给其他国家的人士或居民使用。本平台服务在其他国家不构成向任何人士要约、购买投资产品或其他产品服务的邀请。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">三</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台经营者对本平台中所示的任何商标、文字图案、标志拥有所有权，未经本平台的书面批准，任何人不得使用。本平台所刊登的资料受版权保护，未经本平台书面同意，该资料任何部分均不得修改、复制、储存于检索系统、传送、抄袭、分发，或用于任何商业或公开用途。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">四</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台为您提供专业的服务，需要对您资质进行评估和审核。您是否符合享受本平台的服务条件，最终需要您所具备的资质及遵守本平台公布的规则。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">五</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、任何在本平台出现的信息均只作为参考，您须对任何自主决定的行为负责。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">六</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台不对因本平台资料全部或部分内容产生的或因依赖该资料而引致的任何损失承担任何责任。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">七</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、对于任何因使用或信赖从本平台或资源上获取的内容、服务或其他材料而造成（或声称造成）的任何直接或间接损失，本平台均不承担任何责任。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">八</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台经营者不为在本平台使用的任何第三方软件的准确性、安全性、有效性等作任何声明或保证。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">九</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台某些部分可能包括的单独条款和条件，是作为对本声明的补充。如果有任何冲突，该等附加条款和条件将对相关部分或网页适用。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> </span
        ><span style="font-family:宋体; font-size:10.5pt">十</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、互联网传输可能会受到干扰，中断、延迟或数据错误，本平台经营者对于非本公司能控制的通讯设施故障可能引致的数据及交易之准确性或及时性不负任何责任。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> 十</span
        ><span style="font-family:宋体; font-size:10.5pt">一</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台经营者并不就以下事项作出声明或保证：使用本平台不会中断；不会出现延误、故障、错误、遗漏或丢失传送的资料；不会传播病毒或其他污染或毁灭性的产物；不会损害您的电脑系统。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> 十</span
        ><span style="font-family:宋体; font-size:10.5pt">二</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、当政府部门、司法机关等依照法定程序要求本平台披露有关资料和信息时，本平台不得已将根据执法单位之要求或为公共安全之目的提供资料和信息。在此情况下之任何披露，本平台均可免责。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> 十</span
        ><span style="font-family:宋体; font-size:10.5pt">三</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、平台内容的解释权均归本平台所有。平台内容不排除进行不定期更新，本平台保留对平台包含的信息和资料及其显示的条款、条件和说明进行变更的权利。</span
        >
      </p>
      <p
        style="font-size:10.5pt; line-height:200%; margin:0pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"> 十</span
        ><span style="font-family:宋体; font-size:10.5pt">四</span
        ><span style="font-family:宋体; font-size:10.5pt"
          >、本平台将同步计费系统的门店名称、所在的省、市、区、详细地址、计费系统超市的商品资料、商品销售状态、商品库存、仓库模式、员工账号、员工操作管理权限等数据，阅读并选择本平台，将视为您对此操作的认可。</span
        >
      </p>
    </div>`
    };
  },
  created() {
    window.scroll(0, 0);
  }
};
</script>
<style scoped>
.Agreement {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  line-height: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Agreement.vue